import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as ArrowDown } from '@/shared/assets/desktop/chevron-down.svg'
import { classNames } from '@/shared/lib/utils/classNames'
import useClickOutside from '@/shared/lib/hooks/useClickOutside'
import { CSSTransition } from 'react-transition-group'
import { ReactComponent as GBflag } from '@/shared/assets/desktop/gbFlag.svg'
import { ReactComponent as FinFlag } from '@/shared/assets/desktop/finFlag.svg'

import cls from './select.module.scss'

export const Select = ({ options, className, title, selected, setValue, multiOptions }) => {
    const [expanded, setExpanded] = useState(false)

    const selectRef = useRef()

    useEffect(() => {
        window.addEventListener('scroll', () => setExpanded(false))

        return () => {
            window.removeEventListener('scroll', () => setExpanded(false))
        }
    })

    const arrowHandler = () => {
        setExpanded(!expanded)
    }

    useClickOutside(selectRef, () => setExpanded(false))

    const renderOption = (item, index) => (
        <div
            className={classNames(cls.selectOption, [], {
                [cls.firstOption]: index === 0,
                [cls.lastOption]: index === options.length - 1,
                [cls.selected]: selected === item,
            })}
            onClick={() => setValue(item)}
            key={index}
        >
            {item == 'en' ? <GBflag /> : <FinFlag />}
            <p>{item}</p>
        </div>
    )

    return (
        <div
            ref={selectRef}
            onClick={arrowHandler}
            className={classNames(cls.SelectContainer, [className])}
        >
            <div className={cls.selected}>
                {selected == 'en' ? <GBflag /> : <FinFlag />}
                <p>{title ? title : selected}</p>
            </div>
            <CSSTransition
                in={expanded}
                timeout={300}
            >
                <div
                    className={classNames(cls.selectMenu, [], {
                        [cls.expanded]: expanded,
                    })}
                >
                    {options.map((item, index) => {
                        return renderOption(item, index)
                    })}
                </div>
            </CSSTransition>
            <ArrowDown
                className={classNames(cls.Icon, [], {
                    [cls.expanded]: expanded,
                })}
                type="select-arrow"
            />
        </div>
    )
}
